import React from "react";

import Avatar from "@mui/material/Avatar";
import PersonIcon from "@mui/icons-material/Person";
import GroupIcon from "@mui/icons-material/Group";

// My Files
import { avatarSrc } from "../../utility";

// Hoisted so emotion serialises each size once instead of once per instance,
// which matters on screens that render hundreds of avatars.
const SIZE_SX = {
    small: { width: 24, height: 24 },
    medium: { width: 40, height: 40 },
    large: { width: 56, height: 56 },
};

function getInitials(userOrHub) {
    if (!userOrHub) {
        return "";
    }

    if (userOrHub.firstName || userOrHub.lastName) {
        // Is a user
        return (
            (userOrHub.firstName ? userOrHub.firstName[0] : "") +
            (userOrHub.lastName ? userOrHub.lastName[0] : "")
        );
    }

    if (userOrHub.name) {
        // Is a hub
        return userOrHub.name[0];
    }

    return "";
}

function UserAvatar(props) {
    const { userOrHub, size, variant } = props;

    // The browser fetches, decodes and caches the stored image off the main
    // thread, so point <img> straight at the URL. Screens that run an image
    // through the avatar editor attach a data URI as `avatar`; honour that first
    // so an unsaved edit still previews.
    const src = avatarSrc(userOrHub);
    const initials = getInitials(userOrHub);

    return (
        <Avatar
            alt="Profile Picture"
            src={src}
            variant={variant}
            sx={SIZE_SX[size]}
        >
            {initials ||
                (userOrHub && userOrHub.hub ? <GroupIcon /> : <PersonIcon />)}
        </Avatar>
    );
}

// Lists re-render on every keystroke in their search box; the avatars in them
// only change when their user does.
export default React.memo(UserAvatar);
